import React from "react";
import broken_url_img from "../../imgs/broken_url.png";

const WebpageNotAvailable = (props) => {

  if(props.img!=="maintenance") {
    return (
      <React.Fragment>
        <img src={broken_url_img} alt="broken_URL" className="err_img" />
        <p className="error" style={{fontSize: '2em', marginTop: '10px', color: 'rgb(12, 89, 127)'}}>{props.info}</p>
      </React.Fragment>
    );
  } 
}

export default WebpageNotAvailable;